// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"3317e04e","108":"4ada4b85","163":"80da06be","213":"0361ad99","224":"a7a0995e","267":"3b7ef7e6","333":"66f05a32","481":"57e0394a","594":"48472733","632":"6f4b257b","636":"2e1560ad"}[chunkId] + ".chunk.js";
};